import { api } from "./client";
import type { MediaClip } from "./media";

export interface StockMusicItem {
  id: string;
  title: string;
  mood: string;
  bpm: number | null;
  duration_ms: number;
  file: string;
  url: string;
}

export interface StockSfxItem {
  id: string;
  title: string;
  category: string;
  duration_ms: number;
  file: string;
  url: string;
}

export async function fetchMusicCatalog(): Promise<StockMusicItem[]> {
  const r = await api.get("/stock/music/");
  return r.data;
}

export async function fetchSfxCatalog(): Promise<StockSfxItem[]> {
  const r = await api.get("/stock/sfx/");
  return r.data;
}

export async function importStock(
  projectId: number, kind: "music" | "sfx", itemId: string,
): Promise<MediaClip> {
  const r = await api.post("/stock/import/", {
    project_id: projectId, kind, item_id: itemId,
  });
  return r.data;
}

// ===== Búsqueda en Internet Archive ======================================

export interface WebSearchResult {
  id: string;
  title: string;
  creator: string | null;
  year: string | null;
  downloads: number | null;
  source: "archive_org";
}

export async function searchWebMusic(q: string): Promise<WebSearchResult[]> {
  if (!q.trim()) return [];
  const r = await api.get("/stock/web/search/", { params: { q }, timeout: 20_000 });
  return r.data.results || [];
}

export async function getWebTrackUrl(id: string): Promise<{ url: string; file: string }> {
  const r = await api.get("/stock/web/track/", { params: { id }, timeout: 20_000 });
  return r.data;
}

export async function importWebTrack(
  projectId: number, archiveId: string, title?: string,
): Promise<MediaClip> {
  const r = await api.post("/stock/web/import/",
    { project_id: projectId, archive_id: archiveId, title },
    { timeout: 180_000 });
  return r.data;
}
